import useFetchLiveChat from 'app/hooks/fetch/useFetchLiveChat';
import { useMemo } from 'react';

export default function useLiveChatPromptDisabled() {
  const { data: liveChat } = useFetchLiveChat();

  const disableInput = useMemo(() => {
    const refIds: (string | undefined)[] = ['online:contact-info', 'offline:contact-info'];
    const disabled = liveChat?.chat_items.some((item) => item.type === 'disable_typing_area');
    if (disabled) return true;

    const contactForm = liveChat?.chat_items.find((item) => item.type === 'form' && refIds.includes(item.ref_id));

    return !contactForm?.completed && contactForm?.blocking;
  }, [liveChat]);

  return disableInput;
}
